import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Card, Col, Row, Typography } from 'antd';

import AiIcon from '../../../../../components/AiIcon';

import { useHomeMessageId } from '../../../hooks/useHomeMessageId';

const { Title, Paragraph } = Typography;
const securityPng = '/home/assets/security.png';

const securityCards = [
  {
    titleKey: 'security.apiKeys.title',
    textKey: 'security.apiKeys.text',
    icon: 'security-apiKeys',
  },
  {
    titleKey: 'security.server.title',
    textKey: 'security.server.text',
    icon: 'security-server',
  },
  {
    titleKey: 'security.twoFactor.title',
    textKey: 'security.twoFactor.text',
    icon: 'security-2fa',
  },
];

const SecurityCard = ({
  icon,
  textId,
  titleId,
}: {
  icon: string;
  textId: string;
  titleId: string;
}) => (
  <Card className="home-page__security-card" variant="borderless">
    <Title level={3}>
      <FormattedMessage id={titleId} />
    </Title>
    <AiIcon name={icon} />
    <Paragraph>
      <FormattedMessage id={textId} />
    </Paragraph>
  </Card>
);

const SecuritySection = () => {
  const homeMessageId = useHomeMessageId();

  return (
    <section className="home-page__security" id="security">
      <div className="home-page__section-frame">
        <div className="home-page__security-heading">
          <Title level={2}>
            <FormattedMessage id={homeMessageId('security.title')} />
          </Title>
          <Paragraph>
            <FormattedMessage id={homeMessageId('security.text')} />
          </Paragraph>
        </div>
        <div className="home-page__security-layout">
          <div
            className="home-page__security-visual"
            aria-hidden
            style={{
              backgroundImage: `url(${securityPng})`,
              backgroundRepeat: 'no-repeat',
            }}
          />
          <Row className="home-page__security-grid" gutter={[41, 31]}>
            {securityCards.map((card) => (
              <Col xs={24} sm={12} xl={12} key={card.titleKey}>
                <SecurityCard
                  icon={card.icon}
                  titleId={homeMessageId(card.titleKey)}
                  textId={homeMessageId(card.textKey)}
                />
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;
